// src/components/Sidebar.js - With proper logout and feature flags
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import HelpIcon from '@mui/icons-material/Help';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { authService } from '../services/api';
import { isFeatureEnabled } from '../config/features';
import SquareHalfIcon from './SquareHalfIcon';
import UserProfileModal from '../pages/UserProfilePage';
import userIcon from '../assets/ref-use/user-icon.png';
import eventsIcon from '../assets/ref-use/events-icon.png';
import helpIcon from '../assets/ref-use/help-icon.png';
import navbarIcon from '../assets/ref-use/navbar-icon.png';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const currentUser = authService.getCurrentUser();
  const isBQMUser = currentUser?.email === 'bqm@j49.com';
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showHelpPopup, setShowHelpPopup] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleHelpClick = () => {
    setShowHelpPopup(true);
  };

  const closeHelpPopup = () => {
    setShowHelpPopup(false);
  };

  const handleProfileClick = () => {
    setShowProfileModal(true);
  };

  const closeProfileModal = () => {
    setShowProfileModal(false);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <img src={navbarIcon} alt="Menu" onClick={toggleSidebar} style={{ cursor: 'pointer' }} className="navbar-icon" />
        <div 
          className="sidebar-avatar clickable-avatar" 
          onClick={handleProfileClick}
          title="View Profile"
        >
          {!isCollapsed && <span>{currentUser?.name || 'User'}</span>}
        </div>
      </div>

      <div className="sidebar-menu">
        {isFeatureEnabled('SHOW_HOME_NAV') && (
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className={`menu-item ${path === '/' ? 'active' : ''}`}>
              <HomeIcon className="menu-item-icon" />
              {!isCollapsed && <span>Home</span>}
            </div>
          </Link>
        )}

        {isBQMUser && (
          <Link to="/j49/calendar" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className={`menu-item ${path === '/j49/calendar' ? 'active' : ''}`}>
              <CalendarMonthIcon className="menu-item-icon" />
              {!isCollapsed && <span>Calendar</span>}
            </div>
          </Link>
        )}

        {isFeatureEnabled('SHOW_EVENTS_NAV') && (
          <Link to="/events" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className={`menu-item ${path === '/events' || path.includes('/events/') || path.includes('/event/') ? 'active' : ''}`}>
              <EventIcon className="menu-item-icon" />
              {!isCollapsed && <span>Events</span>}
            </div>
          </Link>
        )}

        {isFeatureEnabled('SHOW_VENDORS_NAV') && (
          <Link to="/vendors" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className={`menu-item ${path === '/vendors' || path.includes('/vendors/') ? 'active' : ''}`}>
              <BusinessIcon className="menu-item-icon" />
              {!isCollapsed && <span>Vendors</span>}
            </div>
          </Link>
        )}

      </div>

      <div className="sidebar-bottom">
        <div className="menu-item" onClick={handleLogout} style={{ cursor: 'pointer' }}>
          <LogoutIcon className="menu-item-icon" />
          {!isCollapsed && <span>Logout</span>}
        </div>
        
        <div className="sidebar-help" onClick={handleHelpClick} style={{ cursor: 'pointer' }}>
          <HelpIcon className="menu-item-icon" />
          {!isCollapsed && <span>Help </span>}
        </div>
      </div>
      
      {/* Help Popup Modal */}
      {showHelpPopup && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={closeHelpPopup}
        >
          <div 
            style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '10px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              textAlign: 'center',
              maxWidth: '400px',
              width: '90%'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ marginBottom: '20px', color: '#1e514b' }}>Need Help?</h3>
            <p style={{ marginBottom: '20px', color: '#666', lineHeight: '1.6' }}>
              For support, questions, or feedback, please contact us at:
            </p>
            <p style={{ 
              fontSize: '18px', 
              fontWeight: 'bold', 
              color: '#1e514b',
              marginBottom: '20px',
              wordBreak: 'break-all'
            }}>
              agarwal.abhinav22@gmail.com
            </p>
            <button 
              onClick={closeHelpPopup}
              style={{
                backgroundColor: '#1e514b',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
      
      {/* User Profile Modal */}
      <UserProfileModal 
        isOpen={showProfileModal} 
        onClose={closeProfileModal} 
      />
    </div>
  );
};

export default Sidebar;